/**
 * @typedef {{ product_id: number, count: number , check: boolean }} ProductAjax
 */
/**
 * Update One
 * @param { ProductAjax } data
 * @returns {Promise<void>}
 */
export const updateCartProduct = async (data) => {
  const URI = '/v1/cart/update';
  return new Promise(((resolve, reject) => {
    window.promiseQueue.add('change-cart', async () => window.axios.put(
      URI,
      data,
    ).then((response) => {
      resolve(response);
    })
      .catch((err) => {
        reject(err);
      }));
  }));
};

/**
 * Update Many
 * @param {ProductAjax[]} data
 * @returns {Promise<void>}
 */
export const updateCart = async (data) => {
  const URI = '/v1/cart/update/bulk';
  return new Promise(((resolve, reject) => {
    window.promiseQueue.add('change-cart', async () => window.axios.put(
      URI,
      data,
    ).then((response) => {
      resolve(response);
    })
      .catch((err) => {
        reject(err);
      }));
  }));
};

/**
 * Remove Many
 * @param {[number]} data
 * @returns {Promise<void>}
 */
export const clearCart = async (data) => {
  const URI = '/v1/cart/remove/bulk';
  return new Promise(((resolve, reject) => {
    window.promiseQueue.add('change-cart', async () => window.axios.put(
      URI,
      data,
    ).then((response) => {
      resolve(response);
    })
      .catch((err) => {
        reject(err);
      }));
  }));
};
